module.exports = __webpack_public_path__ + "img/LsgAudio10-13.0abc56cb.jpeg";